import type { RenderContext } from "./canvas-surface";
/** Bounded font-dependent measurements shared by decorative text and role labels. */
let generation = 0;
let measurements = 0;
let hits = 0;
const widths = new Map<string, number>();
const resets = new Set<() => void>();
if (typeof document !== "undefined")
  document.fonts?.addEventListener("loadingdone", () => {
    generation++;
    widths.clear();
    for (const reset of resets) reset();
  });
export function onTextCacheReset(reset: () => void) {
  resets.add(reset);
}
export function measuredWidth(ctx: RenderContext, value: string) {
  const key = ctx.font + "\n" + value;
  const cached = widths.get(key);
  if (cached !== undefined) {
    hits++;
    widths.delete(key);
    widths.set(key, cached);
    return cached;
  }
  measurements++;
  const width = ctx.measureText(value).width;
  if (key.length < 2048) {
    if (widths.size >= 4096) widths.delete(widths.keys().next().value!);
    widths.set(key, width);
  }
  return width;
}
export const textCacheStats = () => ({
  generation,
  measurements,
  hits,
  widths: widths.size,
});
